import CtsView from '../CtsView.vue'
import CtsList from '../Pages/CtsList.vue'
import CtsWizard from '../Pages/CtsWizard.vue'
import CtsDetail from '../Pages/CtsDetail.vue'

const routes = [
  {
    path: '/cts',
    component: CtsView,
    children: [
      { path: '', name: 'cts-list', component: CtsList },
      { path: 'calcular', name: 'cts-calculate', component: CtsWizard },
      { path: ':id', name: 'cts-detail', component: CtsDetail },
    ],
  },
]

export default routes
